/**
 *
 * Asynchronously loads the component for DoNotAcceptOpenCases
 *
 */

import loadable from "../../utils/loadable";

export default loadable(() => import("./index"));
